module.exports = __webpack_public_path__ + "static/media/people03.2fac67c3.png";